import { render, staticRenderFns } from "./AstaPokerHeaderActions.vue?vue&type=template&id=02317acc&scoped=true&"
import script from "./AstaPokerHeaderActions.vue?vue&type=script&lang=js&"
export * from "./AstaPokerHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./AstaPokerHeaderActions.vue?vue&type=style&index=0&id=02317acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02317acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02317acc')) {
      api.createRecord('02317acc', component.options)
    } else {
      api.reload('02317acc', component.options)
    }
    module.hot.accept("./AstaPokerHeaderActions.vue?vue&type=template&id=02317acc&scoped=true&", function () {
      api.rerender('02317acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AstaPokerHeaderActions.vue"
export default component.exports